import { FeedPartnershipDetails } from "@routes/Article/utils/types";

type CardPartnershipProps = {
  /** Optional additional styling for the container*/
  className?: string;
  /** Optional additional styling for the partnership message*/
  messageClassName?: string;
  /** Optional additional styling for the partnership name*/
  nameClassName?: string;
  /** The text to display as Partnership text. */
  partnership?: FeedPartnershipDetails;
};

/**
 * CardPartnership component that renders a Partnership text.
 * It is used to display additional information or context for the card.
 * https://www.figma.com/design/xsbEGttNPBTNUi388qtSJD/PODCASTS--WEB-?node-id=3397-330742&t=Rc3p8bM01UozhUND-4
 */
const CardPartnership = ({
  className,
  partnership,
  messageClassName,
  nameClassName,
}: CardPartnershipProps): React.ReactElement => {
  if (!partnership) return <></>;

  return (
    <div data-testid="card-partnership-component" className={className}>
      <span className={messageClassName}>
        {`${partnership.partnershipMessage}:`}
      </span>

      <span className={nameClassName}> {partnership?.partnerName}</span>
    </div>
  );
};

export default CardPartnership;
